import Vue from 'vue'
import Vuex from 'vuex'
import localStorage from 'local-storage'

Vue.use(Vuex)
var state = {};
try {
  state = {
    count: localStorage.get('counter') || 0,
    userData: {
      logged: localStorage.get('userData.logged') || false,
      httpHeader: localStorage.get('userData.httpHeader') || '',
      name: localStorage.get('userData.name') || '',
      permissions: localStorage.get('userData.permissions') || [],
      userInfo: localStorage.get('userData.userInfo') || {}
    },
    storeId: localStorage.get('storeId') || ""
  }
} catch (err){
  state = {
    count: localStorage.get('counter') || 0,
    userData: {
      logged: false,
      httpHeader: '',
      name: '',
      permissions: [],
      userInfo: {}
    },
    storeId: "-1"
  }
}


// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  logUser (state, payload) {
    state.userData.logged = true
    state.userData.httpHeader = 'Basic ' + payload.user.token
    state.userData.name = payload.user.name;
    state.userData.permissions = payload.user.permissions;
    state.userData.userInfo = payload.user.userInfo
    localStorage.set('userData.permissions', payload.user.permissions)
    localStorage.set('userData.name', payload.user.name)
    localStorage.set('userData.userInfo', payload.user.userInfo)
    localStorage.set('userData.logged', state.userData.logged)
    localStorage.set('userData.httpHeader', 'Basic ' + payload.user.token)
  },
  logout (state) {
    state.userData.logged = false
    state.userData.httpHeader = ''
    state.userData.name = '';
    state.userData.permissions = []
    state.userData.userInfo = ""
    localStorage.remove('userData.logged')
    localStorage.remove('userData.name')
    localStorage.remove('userData.permissions')
    localStorage.remove('userData.httpHeader')
    localStorage.remove('userData.userInfo')
    localStorage.remove('storeId')
  },
  storeId (state, payload) {
    state.storeId = payload.storeId
    localStorage.set('storeId', payload.storeId)
  }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  // increment: ({ commit }) => commit('increment'),
  // decrement: ({ commit }) => commit('decrement')
}

// getters are functions
const getters = {
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js